import { createFileRoute, redirect } from '@tanstack/react-router'
import { StatusCodes } from 'http-status-codes'

export const Route = createFileRoute('/(redirects)/events')({
  loader: () => {
    throw redirect({ to: '/event', search: true, statusCode: StatusCodes.MOVED_PERMANENTLY })
  },
})
